exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-14fc709e]{text-align:center}@media only screen and (max-width:600px){th[data-v-14fc709e]{font-size:.8rem}}td[data-v-14fc709e]{text-align:center;padding-top:10px!important;padding-bottom:5px!important}@media only screen and (max-width:600px){td[data-v-14fc709e]{font-size:.8rem}}.button3[data-v-14fc709e]{float:right;margin-top:30px;margin-right:10px}.modal[data-v-14fc709e]{top:10%}@media only screen and (max-width:600px){.modal[data-v-14fc709e]{top:0}}.total[data-v-14fc709e]{font-weight:700}.modal-header[data-v-14fc709e]{padding-bottom:5px}.modal-title[data-v-14fc709e]{padding-top:10px}.modal-dialog[data-v-14fc709e]{overflow-y:initial!important}.modal-body[data-v-14fc709e]{height:auto;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14fc709e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/domains-storage/storageDetails.vue
// module id = ffNF
// module chunks = 0